import z from "zod";

const dbErrorTypeValues = [
  "INVALID_ADDRESS_COORDINATES",
  "PRISMA_CLIENT_RUST_PANIC",
  "PRISMA_CLIENT_KNOWN_REQUEST_ERROR",
  "INVALID_ENUM_VALUE",
  "APPEND_ONLY_TABLE_MUTATION",
  "BID_REQUEST_SUNRUN_RECORD_ID_CONFLICT",
  "PROXY_PHONE_NUMBER_USED_AS_CONTACT",
  "SYSTEM_PHONE_NUMBER_USED_AS_CONTACT",
  "ACTIVE_QUOTE_AND_ACTIVE_QUOTE_VERSION",
  "ESTIMATE_CONVERSION_VERSION_MISSING_MAPPINGS",
  "FILE_TAG_APPROVAL_READBACK_MISSED",
  "REQUEST_FOR_QUOTE_NOT_FOUND",
  "CHANGE_ORDER_NOT_FOUND",
  "CHANGE_ORDER_LINE_ITEM_NOT_FOUND",
  "ESCROW_NOT_ON_REQUEST_FOR_QUOTE",
  "FINANCING_NOT_ON_REQUEST_FOR_QUOTE",
  "QUOTE_VERSION_NOT_ON_REQUEST_FOR_QUOTE",
  "QUOTE_VERSION_ARCHIVED",
  "VENDOR_CREDIT_NOT_FOUND",
  "CREDIT_MEMO_NOT_FOUND",
  "RECRUITING_ROOFER_NOT_FOUND",
  "RECRUITING_MARKET_NOT_FOUND",
  "RECRUITING_ACTIVITY_NOT_FOUND",
  "RECRUITING_ACTIVITY_TRIAGE_NOT_FOUND",
  "RECRUITING_IMPORT_ROW_NOT_FOUND",
  "REIMBURSEMENT_NOT_FOUND",
  "ROUTING_TERRITORY_NOT_FOUND",
  "INVOICE_NOT_FOUND",
  "BILL_NOT_FOUND",
  "WORK_ORDER_NOT_FOUND",
  "TASK_NOT_FOUND",
  "TASK_CREATE_FK_VIOLATION",
  "TASK_CREATE_INVARIANT_VIOLATION",
  "TICKET_NOT_FOUND",
  "QUERY_TIMEOUT",
  "SERVICE_AREA_NOT_FOUND",
  "QA_COVERED_PROJECT_NOT_FOUND",
  "PROJECT_OWNER_REMOVE_FILTER_TOO_BROAD",
  "PROJECT_OWNER_BATCH_UPDATE_MATCHED_NOTHING",
  "PROPERTY_ADDRESS_NOT_FOUND",
  "HOME_BASE_EDIT_OF_ADDRESS_PAST_PRE_PRODUCTION",
  "CONTRACTOR_PROFILE_NOT_FOUND",
  "KEY_VALUE_NULLISH_VALUE",
  "UNAUTHORIZED_GROUP_COLUMN",
  "MISSING_DATE_BUCKET_BOUNDARIES",
  "SPATIAL_OVERLAY_FAILURE",
  "PROXY_PHONE_NOT_FOUND",
  "PROXY_PHONE_ASSIGNMENT_NOT_FOUND",
  "PROXY_PHONE_IS_DEDICATED",
  "HOMEOWNER_PHONE_HAS_DEDICATED_PROXY",
  "ACTIONABILITY_FILTER_WITHOUT_MILESTONE_CONTEXT",
  "PHONE_NOT_FOUND",
  "WORK_SITE_NOT_FOUND",
  "WORK_SITE_ROLE_ASSIGNMENT_NOT_FOUND",
  "PERSON_TO_SERVICE_AREA_NOT_FOUND",
  "TICKET_TO_TAG_NOT_FOUND",
  "PROPERTY_MODEL_CONVERSION_FAILED",
  "PROPERTY_MODEL_NOT_FOUND",
  "PROPERTY_MODEL_ELEMENT_NOT_FOUND",
  "HOLDUP_NOT_FOUND",
  "BID_NOT_FOUND",
  "BID_DATA_NOT_FOUND",
  "PERSON_NOT_FOUND",
  "DUPLICATE_ESTIMATE_COVERAGE",
  "ESTIMATE_COVERAGE_NOT_FOUND",
  "ESTIMATE_QA_RULE_UNREADABLE",
  "SLA_MATCHER_UNREADABLE",
  "DISPATCH_BUCKET_ROWS_UNREADABLE",
  "ESTIMATE_QA_RULE_NOT_FOUND",
  "AGENT_ACTION_REQUEST_NOT_TASK_TARGETED",
  "SLA_DEFINITION_NOT_FOUND",
  "SLA_DEFINITION_UNREADABLE",
  "PERSON_FAVORITE_NOT_FOUND",
  "WEB_PUSH_SUBSCRIPTION_NOT_FOUND",
  "CALENDAR_APPOINTMENT_NOT_FOUND",
  "TRAINING_MODULE_NOT_FOUND",
  "CONTRACTOR_TRAINING_SESSION_NOT_FOUND",
  "PERSON_SIDEBAR_ROW_NOT_FOUND",
  "TASK_EVENT_INVARIANT_VIOLATION",
  "TASK_EVENT_REASON_NOT_RETIRED",
  "CONVERSATION_BID_LINK_WRITE_RACED",
  "MARKETING_LEAD_CREATE_RACED",
  "MARKETING_LEAD_NOT_FOUND",
  "MARKETING_LEAD_STAGE_CREATE_RACED",
  "CONVERSATION_NOT_FOUND",
  "BID_REQUEST_EXTERNAL_ID_CLAIMED",
  "FINANCING_CANCEL_BLOCKED_DISBURSED",
  "FINANCING_NOT_FOUND",
  "FINANCING_WEBHOOK_EVENT_INSERT_FAILED",
  "INVALID_SQL_IDENTIFIER",
  "MERGE_MANIFEST_PHONE_MISMATCH",
  "PERSON_MERGE_UNMOVABLE_PROJECT_ROLE",
  "RAW_QUERY_ROW_SHAPE_MISMATCH",
  "ESCROW_TERMINAL_STATUS",
  "BLANK_EMAIL_ADDRESS",
  "EMAIL_ADDRESS_NOT_FOUND",
  "TELECOM_PROVIDER_USER_NOT_FOUND",
  "PERSON_PRIMARY_EMAIL_WRITE_RACED",
  "CONTRACTOR_CAPABILITY_GROUPING_NOT_FOUND",
  "CONTRACTOR_CAPABILITY_GROUPING_HAS_LINE_ITEMS",
  "TELECOM_PROVIDER_PHONE_NOT_FOUND",
  "EMAIL_PROVIDER_MAILBOX_NOT_FOUND",
  "PHONE_OWNER_STILL_ENABLED",
  "PHONE_OWNER_REJECTED_BY_DETACH_GUARD",
  "PHONE_DETACH_BATCH_TOO_LARGE",
  "PHONE_PROXY_LOCK_OUTSIDE_TRANSACTION",
  "TASK_EVENT_LOCK_OUTSIDE_TRANSACTION",
  "PHONE_ADOPTION_RACED",
  "WORK_ORDER_CONCESSION_SAME_STATUS_TRANSITION",
  "WORK_ORDER_CONCESSION_ALREADY_OPEN",
  "SOW_CHANGE_PAYLOAD_INVALID",
  "SOW_CHANGE_LOCK_OUTSIDE_TRANSACTION",
  "LOAN_PLAN_NOT_FOUND",
] as const;

const dbErrorTypeSchema = z.enum(dbErrorTypeValues);
export const DbErrorType = dbErrorTypeSchema.enum;
export type DbErrorType = z.infer<typeof dbErrorTypeSchema>;

const queryTimeoutCodeValues = ["3024", "1105", "TerminateAll", "unknown"] as const;
const queryTimeoutCodeSchema = z.enum(queryTimeoutCodeValues);
export const QueryTimeoutCode = queryTimeoutCodeSchema.enum;
export type QueryTimeoutCode = z.infer<typeof queryTimeoutCodeSchema>;
